(function ($) {
	$.fn.tertiaryHeader = function(){
    return this.each(() => {

    if($('body').find('.tertiary-header-wrap'))	
    {
    $('.wrap.container').addClass('tertiary-content');
    }    
    
    })
}

$(() => {
    $('.tertiary-header-wrap').tertiaryHeader(); 
})

})($);


// WEBPACK FOOTER //
// ./scripts/modules/blocks/tertiary-header.js